import noInternetIcon from '../../images/no-internet-connection.png';

const NoInternetIcon = ({ size = 52, className = '', style, alt = '' }) => (
  <img
    src={noInternetIcon}
    alt={alt}
    width={size}
    height={size}
    className={className}
    style={{
      objectFit: 'contain',
      display: 'block',
      background: 'transparent',
      ...style,
    }}
    aria-hidden={!alt}
  />
);

export default NoInternetIcon;
